module.exports = __webpack_public_path__ + "img/8.1593a9c0.jpg";